import { render, staticRenderFns } from "./WatchList.vue?vue&type=template&id=74a77771&scoped=true&"
import script from "./WatchList.vue?vue&type=script&lang=js&"
export * from "./WatchList.vue?vue&type=script&lang=js&"
import style0 from "./WatchList.vue?vue&type=style&index=0&id=74a77771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a77771",
  null
  
)

export default component.exports